import { VuexModule, Module, Action, Mutation, getModule } from 'vuex-module-decorators'
import store from '@/store'

export interface IScanforBubblePackage {
  sizeX: number //长
  sizeY: number //宽
  sizeZ:number //高
  dimensionalWeight:number //体积重
  id:string //运单号
  errorMessage:string //错误信息
  lockLengthWidthHeight:boolean//长宽高是否需要锁定

}

@Module({ dynamic: true, store, name: 'store_scanforbubblepackage' })
class ScanforBubblePackage extends VuexModule implements IScanforBubblePackage {
  public sizeX = 0;
  public sizeY = 0;
  public sizeZ = 0;
  public dimensionalWeight = 0;
  public id = "";
  public errorMessage = "";
  public lockLengthWidthHeight=false;

  @Mutation
  public setSizeX(str) {
    this.sizeX = str;
  }
  @Mutation 
  public setSizeY(num) {
    this.sizeY = num;
  }
  @Mutation
  public setSizeZ(num) {
    this.sizeZ = num;
  }
  @Mutation
  public setDimensionalWeight(num) {
    this.dimensionalWeight = num;
  }
  @Mutation
  public setId(str) {
    this.id = str;
  }
  @Mutation
  public setLockLengthWidthHeight(boolResult) {
    this.lockLengthWidthHeight = boolResult;
  }

  @Mutation
  public setErrorMessage(str) {
    this.errorMessage = str;
  }
}

export const ScanforBubblePackageModule = getModule(ScanforBubblePackage)
